// Simon & Layan 全局点击追踪器（生产版：无 DEBUG 日志，保留图标式加购功能）
(function () {
  'use strict';
  // 仅在 debug=1 参数下输出日志（生产默认关闭）
  var DEBUG = window.location.search.indexOf('debug=1') > -1;
  document.addEventListener('click', function (e) {
    var el = e.target;
    var target = el.closest ? el.closest('[data-action], button, a, input[type="submit"], form') : el;
    if (!target) return;
    var info = {
      time: new Date().toISOString(),
      action: target.getAttribute('data-action') || '',
      tag: target.tagName.toLowerCase(),
      text: (target.textContent || '').trim().slice(0, 40),
      href: target.getAttribute('href') || '',
      formAction: (target.form && target.form.action) || '',
      method: (target.form && target.form.method) || ''
    };
    try {
      var cc = document.querySelector('.cart-count');
      if (cc) info.cartCount = cc.textContent;
    } catch (err) {}
    if (DEBUG) {
      console.log('[CLICK]', info);
    }
    // 真实上报入口：接入 GA4 / Meta Pixel 事件时在此调用
    if (window.slTrack) window.slTrack(info);
  }, true);
  window.slTrack = window.slTrack || function () {};
})();

// ===== 图标式加购按钮（追加：把 .card-actions 改造成图标式）=====
(function () {
  function transformCards() {
    document.querySelectorAll('.card').forEach(function (card) {
      if (card.querySelector('.card-icons')) return;
      var actions = card.querySelector('.card-actions');
      if (!actions) return;
      actions.className = 'card-icons';
      var btn = actions.querySelector('.quick-add-btn, button[type="submit"]');
      if (btn) {
        btn.className = 'card-icon cart-icon';
        btn.textContent = '🛍';
        btn.style.cssText = '';
        btn.setAttribute('aria-label', 'Add to cart');
      }
      var wl = card.querySelector('.wishlist-btn');
      if (wl) wl.classList.add('card-icon');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformCards);
  } else {
    transformCards();
  }
  setTimeout(transformCards, 800);
  setTimeout(transformCards, 2000);
})();

// ===== 图标式加购按钮样式（动态注入 CSS）=====
(function () {
  function injectIconCss() {
    if (document.getElementById('icon-cart-style')) return;
    var css = '.card{position:relative}.card-icons{position:absolute;inset:0;padding:10px;display:flex;justify-content:space-between;align-items:flex-end;pointer-events:none;z-index:8;opacity:0;transition:opacity .3s}.card:hover .card-icons{opacity:1}.card-icons .quick-add{pointer-events:auto;margin:0}.card-icon{width:38px;height:38px;border-radius:50%;border:none;background:rgba(255,255,255,.94);font-size:17px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:.2s;color:#3D3429;box-shadow:0 2px 8px rgba(0,0,0,.12)}.card-icon:hover{background:#3D3429;color:#fff;transform:scale(1.08)}.card .wishlist-btn{opacity:0;transition:opacity .3s;position:absolute;top:10px;right:10px;z-index:9}.card:hover .wishlist-btn{opacity:1}@media(max-width:860px){.card:hover .card-icons{opacity:0}.card:hover .wishlist-btn{opacity:0}.card.show-actions .card-icons{opacity:1}.card.show-actions .wishlist-btn{opacity:1}.card-icons{z-index:8}.wishlist-btn{z-index:9;width:44px;height:44px}.card-icon{width:44px;height:44px;font-size:19px}}';
    var s = document.createElement('style');
    s.id = 'icon-cart-style';
    s.textContent = css;
    document.head.appendChild(s);
  }
  injectIconCss();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectIconCss);
})();